module.exports = __webpack_public_path__ + "static/media/gold.dc99b1fb.png";